var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-choose-product" },
    [
      _c("div", { ref: "wrapper-topbar", staticClass: "wrapper-topbar" }, [
        _c(
          "div",
          { staticClass: "finding" },
          [
            _vm.display.search
              ? _c("div", { staticClass: "search-input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.txtFieldSearch,
                        expression: "txtFieldSearch"
                      }
                    ],
                    ref: "txtfield-search",
                    staticClass: "form-control form-control-sm",
                    attrs: {
                      placeholder: _vm.$t("placeholder.search"),
                      type: "text"
                    },
                    domProps: { value: _vm.txtFieldSearch },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.txtFieldSearch = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light btn-close",
                      on: { click: _vm.handleClickCloseSearch }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ])
              : [
                  _c(
                    "div",
                    {
                      staticClass: "category",
                      on: { click: _vm.handleClickCategoryList }
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.selectedCategoryName) +
                            " (" +
                            _vm._s(_vm.selectedCategoryProductCount) +
                            ")\n          "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.posSettings.menu_online.is_active
                    ? _c(
                        "div",
                        {
                          staticClass: "btn-icon",
                          on: { click: _vm.handleClickNotificationIcon }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "icon" },
                            [
                              _c("BaseNotificationBell", {
                                attrs: { count: _vm.unreadNotificationCount }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.posSettings.menu_online.is_active
                    ? _c(
                        "div",
                        {
                          staticClass: "btn-icon",
                          on: { click: _vm.handleOpenCreateQRCodeForm }
                        },
                        [_vm._m(1)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-icon" },
                    [
                      !_vm.isOffline
                        ? _c(
                            "vs-tooltip",
                            {
                              attrs: {
                                text:
                                  _vm.bills.length > 0
                                    ? _vm.$t(
                                        "message.transactionswillsaveauto",
                                        { number: _vm.bills.length }
                                      )
                                    : _vm.networkMessage,
                                position: "bottom"
                              }
                            },
                            [
                              _vm.bills.length > 0
                                ? _c("div", { staticClass: "sync-count" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.bills.length) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn no-bg",
                                  staticStyle: { cursor: "default" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-wifi",
                                    staticStyle: { "font-size": "15px" }
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isOffline
                        ? _c(
                            "vs-tooltip",
                            {
                              attrs: {
                                text:
                                  _vm.bills.length > 0
                                    ? _vm.$t(
                                        "message.transactionswillsaveauto",
                                        { number: _vm.bills.length }
                                      )
                                    : _vm.networkMessage,
                                position: "bottom"
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "btn no-bg",
                                  staticStyle: { cursor: "default" }
                                },
                                [
                                  _vm.bills.length > 0
                                    ? _c("div", { staticClass: "sync-count" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.bills.length) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fas fa-wifi text-danger",
                                    staticStyle: { "font-size": "15px" }
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showDiscountButton
                    ? _c(
                        "div",
                        {
                          staticClass: "btn-icon",
                          on: { click: _vm.handleClickDiscountIcon }
                        },
                        [_vm._m(2)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-icon",
                      on: { click: _vm.handleClickSearchIcon }
                    },
                    [_vm._m(3)]
                  )
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wrapper-scrollable",
          style: [{ height: _vm.wrapperScrollableHeight + "px" }]
        },
        [
          !_vm.display.search
            ? _c(
                "div",
                { staticClass: "wrapper-sections" },
                [
                  _vm.use_queue
                    ? _c("QueueButton", {
                        staticClass: "btn-queue",
                        attrs: { loaded: _vm.loaded }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.use_table
                    ? _c("TableButton", { staticClass: "btn-table" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.use_dining
                    ? _c("DiningButton", { staticClass: "btn-dining" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user_customer
                    ? _c("CustomerButton", { staticClass: "btn-customer" })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.filterProducts, function(item, index) {
            return item.category_id == _vm.category_id
              ? _c(
                  "div",
                  {
                    key: index,
                    staticClass: "wrapper-products",
                    staticStyle: { height: "100%" }
                  },
                  [
                    _c("RecycleScroller", {
                      staticClass: "scroller",
                      attrs: {
                        items: item.products,
                        itemSize: 80,
                        keyField: "product_id"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var product = ref.item
                              var productIndex = ref.index
                              return [
                                _c(
                                  "div",
                                  {
                                    key: productIndex,
                                    staticClass: "product",
                                    class: [
                                      {
                                        disabled:
                                          _vm.isSinglePriceAndIsNotAvailable(
                                            product
                                          ) ||
                                          _vm.isSinglePriceAndOutOfStock(
                                            product
                                          )
                                      }
                                    ],
                                    staticStyle: { width: "100%" },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectedProduct(product)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "image" }, [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            product.images.thumbnail ||
                                            _vm.defaultImages.product
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "detail" }, [
                                      _c("div", { staticClass: "info" }, [
                                        _c("span", { staticClass: "name" }, [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(product.product_name) +
                                              "\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "icons" },
                                          [
                                            _vm.isSyncWithWarehouse(product)
                                              ? _c(
                                                  "vs-tooltip",
                                                  {
                                                    staticStyle: {
                                                      float: "left",
                                                      margin: "0 2px"
                                                    },
                                                    attrs: {
                                                      text: _vm
                                                        .$t(
                                                          "apps.inventory.message.stockquantity"
                                                        )
                                                        .toLowerCase(),
                                                      position: "top"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-secondary",
                                                        staticStyle: {
                                                          height: "15px",
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                          "justify-content":
                                                            "center",
                                                          "font-size": "9px",
                                                          position: "relative",
                                                          top: "-1px",
                                                          "margin-left": "-1px"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-box-open",
                                                          staticStyle: {
                                                            "margin-right":
                                                              "2px"
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.stockCount(
                                                                product
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isCustomPrice(product) &&
                                            !_vm.isSinglePriceAndIsNotAvailable(
                                              product
                                            ) &&
                                            !_vm.isSinglePriceAndOutOfStock(
                                              product
                                            )
                                              ? _c(
                                                  "vs-tooltip",
                                                  {
                                                    staticStyle: {
                                                      float: "left",
                                                      margin: "0 3px",
                                                      cursor: "pointer"
                                                    },
                                                    attrs: {
                                                      text: _vm
                                                        .$t(
                                                          "message.customprice"
                                                        )
                                                        .toLowerCase(),
                                                      position: "top"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-secondary",
                                                        staticStyle: {
                                                          height: "15px",
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                          "justify-content":
                                                            "center",
                                                          "font-size": "9px",
                                                          position: "relative",
                                                          top: "-1px"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-calculator"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isCustomAttr(product) &&
                                            _vm.isProductUseLot(product)
                                              ? _c(
                                                  "vs-tooltip",
                                                  {
                                                    staticStyle: {
                                                      float: "left",
                                                      margin: "0 2px",
                                                      cursor: "pointer"
                                                    },
                                                    attrs: {
                                                      text: _vm
                                                        .$t("message.chooselot")
                                                        .toLowerCase(),
                                                      position: "top"
                                                    }
                                                  },
                                                  [
                                                    _vm.isSyncWithWarehouse(
                                                      product
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-secondary",
                                                            staticStyle: {
                                                              height: "15px",
                                                              display: "flex",
                                                              "align-items":
                                                                "center",
                                                              "justify-content":
                                                                "center",
                                                              "font-size":
                                                                "9px",
                                                              position:
                                                                "relative",
                                                              top: "-1px"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-pallet"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.isCustomAttr(product) &&
                                            _vm.isProductUseSerial(product)
                                              ? _c(
                                                  "vs-tooltip",
                                                  {
                                                    staticStyle: {
                                                      float: "left",
                                                      margin: "0 2px",
                                                      cursor: "pointer"
                                                    },
                                                    attrs: {
                                                      text: _vm
                                                        .$t(
                                                          "message.chooseserial"
                                                        )
                                                        .toLowerCase(),
                                                      position: "top"
                                                    }
                                                  },
                                                  [
                                                    _vm.isSyncWithWarehouse(
                                                      product
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-secondary",
                                                            staticStyle: {
                                                              height: "15px",
                                                              display: "flex",
                                                              "align-items":
                                                                "center",
                                                              "justify-content":
                                                                "center",
                                                              "font-size":
                                                                "9px",
                                                              position:
                                                                "relative",
                                                              top: "-1px"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-sd-card"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            [
                                              _vm.isSinglePriceAndIsNotAvailable(
                                                product
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "badge badge-danger",
                                                      staticStyle: {
                                                        "font-size": "9px",
                                                        position: "relative",
                                                        top: "-1px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.productisnotavailable"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isSinglePriceAndOutOfStock(
                                                product
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "badge badge-danger",
                                                      staticStyle: {
                                                        "font-size": "9px",
                                                        position: "relative",
                                                        top: "-1px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.outofstock"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ],
                                          2
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "price" }, [
                                        _vm.isFixedPrice(product)
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.getNumber(
                                                      product.prices[0].price
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                          : _vm.isCustomPrice(product)
                                          ? _c("span", [
                                              _c(
                                                "span",
                                                { staticClass: "comma" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.variableprice"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              product.prices.length == 1 &&
                                              product.modifiers.length > 0
                                                ? _c(
                                                    "span",
                                                    { staticClass: "comma" },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.modifiers"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          : _c("span", [
                                              product.prices.length > 1
                                                ? _c(
                                                    "span",
                                                    { staticClass: "comma" },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.pos.message.prices",
                                                              {
                                                                number:
                                                                  product.prices
                                                                    .length
                                                              }
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              product.modifiers.length > 0
                                                ? _c(
                                                    "span",
                                                    { staticClass: "comma" },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.modifiers"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "wrapper-bottombar", staticClass: "wrapper-bottombar" },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  on: { click: _vm.onBackToDashboard }
                },
                [_c("i", { staticClass: "fas fa-power-off" })]
              ),
              _vm._v(" "),
              _c("PrintButton"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-light btn-order-number",
                  class: [_vm.orderTotalClass],
                  attrs: { disabled: _vm.disabledViewOrders },
                  on: { click: _vm.handleClickOrderCount }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.ordersCountText) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("TotalPriceButton", {
                staticClass: "btn-submit-order",
                attrs: { disabled: "false" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("BaseSelectLotNumberModal", {
        attrs: {
          show: _vm.lotModal.show,
          loading: _vm.lotModal.loading,
          lots: _vm.lotList,
          selected: _vm.lot.selected,
          index: 0,
          skuId: _vm.lot.skuId
        },
        on: {
          onClose: _vm.handleCloseLotModal,
          onCancel: _vm.handleCancleLotModal,
          onSubmit: _vm.handleSumitLotModal,
          onSortChange: _vm.handleSortLotChange
        }
      }),
      _vm._v(" "),
      _c("BaseSelectSerialNumberModal", {
        attrs: {
          show: _vm.serialModal.show,
          loading: _vm.serialModal.loading,
          serials: _vm.serialList,
          selected: _vm.serial.selected,
          index: 0,
          skuId: _vm.serial.skuId
        },
        on: {
          onClose: _vm.handleCloseSerialModal,
          onCancel: _vm.handleCancleSerialModal,
          onSubmit: _vm.handleSumitSerialModal,
          onSortChange: _vm.handleSortSerialChange
        }
      }),
      _vm._v(" "),
      _c("BaseBModalQRCodeForm", {
        attrs: {
          modalTitle: _vm.$t("apps.pos.message.createnewqrcode"),
          formType: "create",
          isSubmitted: _vm.isSubmittedQRCodeForm,
          branches: [_vm.branch],
          posSessions: [_vm.posSession],
          defaultValues: _vm.defaultValues,
          qrcode: _vm.qrcode
        },
        on: { onSubmit: _vm.handleSubmitQRCodeForm }
      }),
      _vm._v(" "),
      _c("BaseBModalQRCodeImage", { attrs: { qrcode: _vm.qrcode } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-sitemap" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", {
        staticClass: "fas fa-qrcode",
        staticStyle: { "font-size": "18px", position: "relative", top: "0px" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-tag" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b8dbde4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8dbde4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/include/ChooseProduct.vue
// module id = null
// module chunks = 